<template>
    <figure class="component-preview" @click="$emit('click', $event);">
        <img v-if="selectedImage" :src="selectedImage" />
        <CaddyPreview v-else-if="component.type === COMPONENT_NAME.caddy && component.config" :caddy="caddyConfig" :markers="false"></CaddyPreview>
        <LadderPreview v-else-if="component.config && component.type === COMPONENT_NAME.ladder" :value="component.config"></LadderPreview>
        <img v-else-if="bigImgPath" :src="bigImgPath" /> <img v-else src="../../static/img/no_image.jpg" />
        <div v-if="!component.is_published" class="not-published abs absCenter">{{ $t("product.notPublished") }}</div>

        <div v-if="component.status" class="status" :style="{ backgroundColor: getStatusColor(component.status.name) }">
            {{ $tradFor(component.status.terms.name) }}
        </div>
    </figure>
</template>

<script>
import CaddyPreview from "./caddy-preview";
import { COMPONENT_NAME } from "@/services/component";
import LadderPreview from "./ladder-preview";
import { centerToBottomLeft } from "@/catalog/caddy-utils";
import Globals from "@/components/globals.js";
import { mapGetters } from "vuex";

export default {
    props: ["component", "imageId"],
    components: { CaddyPreview, LadderPreview },
    data: () => ({ COMPONENT_NAME }),
    computed: {
        ...mapGetters("module/status", ["getStatusColor"]),
        caddyConfig() {
            return this.component.config && centerToBottomLeft(this.component.config);
        },
        bigImgPath() {
            return this.component.figures.big && Globals.getBaseUrl() + this.component.figures.big;
        },
        selectedImage() {
            return (
                this.component.figures_advanced[this.imageId] &&
                this.component.figures_advanced[this.imageId].big &&
                Globals.getBaseUrl() + this.component.figures_advanced[this.imageId].big
            );
        }
    }
};
</script>

<style lang="scss" scoped>
img {
    object-fit: contain;
}

.not-published {
    background-color: var(--color4);

    vertical-align: middle;
    padding: 5px 30px;
    text-align: center;
    border: 2px #fff solid;
    color: #fff;
    font-family: Oswald;
}

.status {
    position: absolute;
    vertical-align: middle;
    padding: 5px 30px;
    text-align: center;
    border: 2px #fff solid;
    color: #fff;
    font-family: Oswald;

    bottom: 20px;
    left: 50%;
    transform: translate(-50%, 0);
    text-transform: capitalize;
}

.component-preview {
    padding-bottom: 100%;
    width: 100%;
    position: relative;
    background-color: white;

    > :first-child {
        position: absolute;
        top: 10px;
        left: 10px;

        // equivalent to bottom/right: 10 but using width/height with calc instead,
        // because otherwise <img> will break
        width: calc(100% - 20px);
        height: calc(100% - 20px);
    }
}
</style>



// WEBPACK FOOTER //
// component-preview.vue?10de091e